import type { AnalyticsEventName, Events } from './events.config';

export type EventInput<E extends AnalyticsEventName = AnalyticsEventName> =
  Events[E] extends undefined
    ? { event: E; payload?: undefined; distinctId?: string }
    : { event: E; payload: Events[E]; distinctId?: string };

export type EventSink = (input: EventInput<AnalyticsEventName>) => void;

type EventErrorReporter = (err: unknown, ctx: { event: AnalyticsEventName }) => void;

const sinkIds = new Set<string>();
const sinks: EventSink[] = [];
let reportError: EventErrorReporter | undefined;

export function registerEventSink(id: string, sink: EventSink): void {
  if (sinkIds.has(id)) return;
  sinkIds.add(id);
  sinks.push(sink);
}

export function setEventErrorReporter(reporter: EventErrorReporter): void {
  reportError = reporter;
}

/** Product analytics only — nest-only names are a type error. */
export function capture<E extends AnalyticsEventName>(input: EventInput<E>): void {
  for (const sink of sinks) {
    try {
      sink(input as EventInput<AnalyticsEventName>);
    } catch (err) {
      reportError?.(err, { event: input.event });
    }
  }
}
